import React, { useContext } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import Context from '../Context';
import NoTask from './NoTask';

export default function RedirectToGreet() {
  const { greets } = useContext(Context);
  const { search } = useLocation();

  if (greets.data.length > 0) {
    const greet = greets.data[0];
    return <Redirect to={`/home/greet/${greet.id}${search}`} />;
  }

  return <NoTask />;
}

export function RedirectToGreetUpload() {
  const { greets } = useContext(Context);
  const { search } = useLocation();

  if (greets.data.length > 0) {
    const greet = greets.data[0];
    return <Redirect to={`/home/greet/${greet.id}/upload${search}`} />;
  }

  return <NoTask />;
}
